import useLazyData from '@/hooks/useLazyData';
import dynamic from 'next/dynamic';
import Skeleton from './skeleton';
import SkeletonV2 from './skeleton-v2';

const DynamicTrendPost = dynamic(() => import('./trend-post'), {
  ssr: false,
  loading: Skeleton
});

const DynamicTrendPostV2 = dynamic(() => import('./trend-post-v2'), {
  ssr: false,
  loading: SkeletonV2
});

const TrendPost = props => {
  const { ref: viewRef, show } = useLazyData({
    threshold: 0.01,
    rootMargin: '10px 0px 0px 0px'
  });

  let isV2 = props.properties?.style === 'v2';

  const skeleton = isV2 ? <SkeletonV2 /> : <Skeleton />;

  if (!show) {
    return <div ref={viewRef}>{skeleton}</div>;
  }

  if (isV2) {
    return <DynamicTrendPostV2 skeleton={skeleton} {...props} />;
  }

  return <DynamicTrendPost skeleton={skeleton} {...props} />;
};

export default TrendPost;
